

import React from 'react';
import AppBaseComponent from '../../../../components/AppBaseComponent';
import { connect } from "react-redux";
import Workflow from './Workflow';
import TransactionSetting from './TransactionSetting';
import AdditionalAttribute from '../../AdditionalAttribute';
import TagComponent from '../../TagComponent';
import TermCondition from '../quotationConfiguration/TermCondition';

class SalesInvoiceConfiguration extends AppBaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            enableTransactionId: 'Y',
            addition_attr_show  :   false,
        }
    }
    render() {

        return (
            <section className="page_containt " style={{ top: "1px" }}>
                <div className="pageTbl bg-white">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                                type="button" role="tab" aria-controls="details" aria-selected="true">General
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="workflow-tab" data-bs-toggle="tab" data-bs-target="#workflow"
                                type="button" role="tab" aria-controls="workflow" aria-selected="false">Workflow
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link " id="attribute-tab" data-bs-toggle="tab" data-bs-target="#attribute"
                                type="button" role="tab" aria-controls="attribute" aria-selected="true" onClick={() => this.setState({addition_attr_show : true})}>Addititonal Attribute
                            </button>
                        </li>
                         <li className="nav-item" role="presentation">
                            <button className="nav-link " id="terms-tab" data-bs-toggle="tab" data-bs-target="#terms"
                                type="button" role="tab" aria-controls="terms" aria-selected="true">Terms & Condition
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link " id="tags-tab" data-bs-toggle="tab" data-bs-target="#tags" type="button" role="tab" aria-controls="tags" aria-selected="true">Tags
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">


                        <div className="tab-pane show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                            <div className="tab_content_header">
                                <TransactionSetting loaded={true} />
                            </div>
                        </div>

                        <div className="tab-pane" id="workflow" role="tabpanel" aria-labelledby="workflow-tab">
                            <div className="tab_content_header">
                                <Workflow />
                            </div>
                        </div>

                        <div className="tab-pane" id="attribute" role="tabpanel"
                            aria-labelledby="attribute-tab">
                            <div className="tab_content_header">
                                {
                                    this.state.addition_attr_show &&
                                    <AdditionalAttribute category="sales_invoice" />
                                }

                            </div>
                        </div>
                        <div className="tab-pane" id="terms" role="tabpanel"
                            aria-labelledby="terms-tab">
                            <div className="tab_content_header">
                                <TermCondition salesOrderKey="sales_invoice" />
                            </div>
                        </div>
                        <div className="tab-pane" id="tags" role="tabpanel" aria-labelledby="tags-tab">
                            <div className="tab_content_header"><TagComponent type="sales_invoice" /></div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(SalesInvoiceConfiguration);